export default __webpack_public_path__ + "static/A_rare_silk_nearly_lost_through_war-6da01ed9a79a05a60c99268d3e5e4033.jpg";